import lang from '../assets/lang/v1';

class langRegister {

    static file = lang;
    static language = "sv";

    static getItem(view, item, lang){
        try {
            let language = "";
            if(!lang){
                language = langRegister.language;
                try{
                    if(sessionStorage.getItem("language")){
                        language = sessionStorage.getItem("language");
                    }
                }catch (e) {}
            }else{
                language = lang;
            }
            if(langRegister.file[view][item][language]){
                return langRegister.file[view][item][language];
            }else{
                return "-";
            }
        }catch (error) {
            return "-";
        }
    }

    static setLanguage(lang){
        langRegister.language = lang;
        try {
            sessionStorage.setItem("language", lang);
        }catch (e) {}
    }

    static getLanguage(){
        try{
            if(sessionStorage.getItem("language")){
                return  sessionStorage.getItem("language");
            }else{
                return langRegister.language;
            }
        }catch (e) {
            return langRegister.language;
        }
    }

    //SHORTENER
    static get(view, item, lang){
        return langRegister.getItem(view, item, lang);
    }

    static set(lang){
        langRegister.setLanguage(lang);
    }

    static lang(){
        return langRegister.getLanguage();
    }

}

export {langRegister}


// WEBPACK FOOTER //
// ./src/services/langRegister.js